import { render, staticRenderFns } from "./ProductOrderDetails.vue?vue&type=template&id=2772464e&scoped=true"
import script from "./ProductOrderDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductOrderDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductOrderDetails.vue?vue&type=style&index=0&id=2772464e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772464e",
  null
  
)

export default component.exports